import { memo } from 'react'

import { RoundCheckboxBold } from '@/shared/icons/RoundCheckboxBold'

import { TOptionProps } from './types'

const OptionComponent = ({
  title,
  index,
  image,
  imageNode,
  emoji,
  decorativeImage,
  description,
  selectOption,
  selectedOptions,
  isOneSelectPage = false,
  customCheckbox,
  showDefaultCircle = false,
  hideIndicator,
}: TOptionProps) => {
  const handleClick = () => {
    return selectOption(index)
  }

  const checkBoxStyles = {
    width: 22,
    height: 22,
    stroke: '#FFF',
  }
  const isSelectedOption = Boolean((index || index === 0) && selectedOptions?.includes(+index))

  let className = 'survey-option'
  if (isSelectedOption) {
    className += ' selected'
  }

  const showIndicator = isOneSelectPage ? hideIndicator === false : !hideIndicator

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div className={className} onClick={handleClick}>
      {image?.src && (
        <div className="image-container">
          <img src={image?.src} alt="" loading="lazy" />
        </div>
      )}

      {emoji && <div className="emoji-container">{emoji}</div>}

      {imageNode && imageNode}

      <div className="content">
        {title && <div className="title" dangerouslySetInnerHTML={{ __html: title }} />}
        {description && <div className="description">{description}</div>}
        {decorativeImage && <div className="decorative-image">{decorativeImage}</div>}
      </div>
      {isSelectedOption && showIndicator && (
        <div className="state-indicator">
          {customCheckbox ? customCheckbox : <RoundCheckboxBold {...checkBoxStyles} />}
        </div>
      )}
      {!isSelectedOption && showDefaultCircle && <div className="circle-container"></div>}
    </div>
  )
}

export const Option = memo(OptionComponent)
